const answer = {
	content: "block+",
	group: "block",
	attrs: {
		mail: { default: null },
		dateTime: { default: null },
	},
};

export default answer;
